import styled from 'styled-components';
import media from '../../../styles/media.style';

import {
  BLACK,
  WHITE,
  NAVIGATION_MOBILE_HEIGHT,
  NAVIGATION_DESKTOP_HEIGHT,
  BG_GRAY,
} from '../../../styles/variables.style';

export const Anchor = styled.span`
  font-size: 14;
  line-height: 1.79;
  letter-spacing: 0.5px;
  color: ${WHITE};
  border-bottom: 1px solid ${WHITE};
  text-transform: uppercase;
  margin-left: 20px;
`;

export const Button = styled.button`
  width: 100%;
  height: 65px;
  background-color: ${BLACK};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: ${WHITE};
  margin-bottom: 5%;
  cursor: pointer;
  border: none;

  :disabled {
    background-color: ${BG_GRAY.COMMON_3};
  }

  ${media.tabletP`
    width: 300px;
    font-size: 12px;
    letter-spacing: 0.8px;
  `};
`;

export const ButtonPlaceholder = styled.div`
  margin-bottom: 5%;
`;

export const Input = styled.input`
  background: transparent;
  border: none;
  border-bottom: 1px solid ${WHITE};
  color: ${WHITE};
  font-size: 16px;
  letter-spacing: 0.1px;
  flex: 1;
  margin: 15% 0;
  padding-bottom: 5px;
  &::-webkit-input-placeholder {
    color: ${WHITE};
  }
  width: 100%;
  max-width: 300px;
  display: block;

  ${media.tabletP`
    font-size: 20px;
    margin: 10% 0 60px;
  `};
`;

export const Subtitle = styled.h3`
  font-size: 16px;
  line-height: 1.56;
  letter-spacing: 0.1px;
  color: ${WHITE};
`;

export const SubtitlePlaceholder = styled.div`
  margin: 1em 0;
`;

export const Text = styled.p`
  font-size: 11px;
  letter-spacing: 0.7px;
  font-weight: 500;
  color: ${WHITE};
  text-align: center;

  ${media.tabletP`
    font-size: 14px;
    letter-spacing: 0.5px;
    text-align: left;
  `};
`;

export const Title = styled.h1`
  font-size: 20px;
  line-height: 1.1;
  margin: 0;
  color: ${WHITE};
  text-transform: uppercase;

  ${media.tabletP`
    font-size: 32px;
    font-weight: 500;
    line-height: 1.25;
    letter-spacing: 0.2px;
  `};
`;

export const Wrapper = styled.div`
  background: gray;
  padding: 20% 15%;
  min-height: calc(100vh - ${NAVIGATION_MOBILE_HEIGHT}px);
  margin-top: ${NAVIGATION_MOBILE_HEIGHT}px;
  background-image: url(${({ bg, w }) => (bg ? `${bg}?w=${Math.floor(w / 3)}&q=100` : 'unset')});

  ${media.x2`
    ::after {
      background-image: url(${({ bg, w }) => (bg ? `${bg}?w=${Math.floor(w / 1.5)}&q=100` : 'unset')});
    }
  `};

  ${media.x3`
    ::after {
      background-image: url(${({ bg }) => (bg ? `${bg}` : 'unset')});
    }
  `};
  background-size: cover;
  background-position: center;

  ${media.tabletP`
    padding: 12% 15% 0;
    min-height: calc(100vh - ${NAVIGATION_DESKTOP_HEIGHT}px);
    margin-top: ${NAVIGATION_DESKTOP_HEIGHT}px;
  `};

  ${media.tabletL`
    padding: 10% 15% 0;
  `};
`;

export const SelectWrapper = styled.div`
  position: relative;
  background-color: transparent;
  border: none;
  height: 36px;
  padding: 0;
  line-height: 36px;
  width: 100%;
  max-width: 300px;
  text-align: left;
  letter-spacing: 1px;
  border-bottom: 1px solid ${WHITE};
  margin-bottom: 25px;

  select {
    width: 100%;
    appearance: none;
    background: transparent;
    border: none;
    font-size: 16px;
    font-weight: 400;
    height: 36px;
    line-height: 36px;
    color: ${WHITE};

    ::-ms-expand {
      display: none;
    }

    ${media.tabletP`
      font-size: 20px;
    `};
  }

  ::before {
    content: '';
    position: absolute;
    top: 55%;
    right: 10px;
    transform: translateY(-50%) rotate(135deg);
    transform-origin: 6px 4px;
    width: 8px;
    height: 8px;
    border-top: 1px solid ${WHITE};
    border-right: 1px solid ${WHITE};
    transition: transform 0.3s;

    ${media.tabletL`
      right: 10px;
    `};
  }
`;

export const PageContent = styled.div`
  form {
    display: flex;
    flex-direction: column;
    margin-top: 20px;

    ${media.tabletP`
      flex-direction: row;
      margin-top: 60px;
    `};
  }
`;

export const LeftFields = styled.div`
  flex: 1;
`;

export const RightFields = styled.div`
  flex: 1;

  input:first-child {
    margin-top: 0;

    ${media.tabletP`
      margin-top: 15%;
    `};
  }

  ${media.tabletP`
    margin-left: 20px;
  `};
`;

export const CountryCityWrapper = styled.div`
  display: flex;
  max-width: 300px;

  > div {
    flex: 1;
    margin-right: 10px;
    margin-bottom: 0;

    ${media.tabletP`
      margin-bottom: 25px;
    `};
  }

  input {
    flex: 1;
    margin-top: 0;
    margin-bottom: 0;

    ${media.tabletP`
      margin-bottom: 25px;
    `};
  }
`;

export const Spinner = styled.span`
  display: inline-block;
  width: 20px;
  height: 20px;

  ::after {
    content: ' ';
    display: block;
    width: 15px;
    height: 15px;
    margin: 1px;
    border-radius: 50%;
    border: 5px solid #fff;
    border-color: #fff transparent #fff transparent;
    animation: spinner 1.2s linear infinite;
  }

  @keyframes spinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/StylistToolPages/SignUpPage/SignUpPage.style.js